import styled, { css } from 'styled-components';
import { utilService } from '../../services/util-service';

interface MapOverlayProps {
  phone?: string;
  role?: string;
  location?: any;
  locations?: any;
  distance?: any;
}

const COLOR = {
  R: css`
    background-color: #0086ff;
  `,
  V: css`
    background-color: #e63528;
  `,
};

const TOP = {
  R: css`
    border-top: 5vh solid #0086ff;
  `,
  V: css`
    border-top: 5vh solid #e63528;
  `,
};

const MapRescueOverlay = ({ phone, role, location, locations, distance }: MapOverlayProps) => {
  const elapsedMinutes = (): any => {
    const selected = locations.find((element) => element.phone === phone);
    if (selected === undefined) {
      return '0';
    }
    const timeDiff =
      new Date(location.saveTime).getTime() - new Date(selected.loc[0].saveTime.replaceAll('-', '/')).getTime();
    return Object.is(timeDiff, NaN) || timeDiff < 0 ? timeDiff : Math.floor(timeDiff / 1000 / 60);
  };

  return (
    <MapOverlayGpxInfo color={role}>
      <ul className="popup-content">
        <li>{utilService.isMobileFormat(phone)}</li>
        <li>
          {utilService.getTime(location.saveTime)} ({elapsedMinutes()}분 경과)
        </li>
        <li>
          {utilService.convertToDms(location.lat, false)} {utilService.convertToDms(location.lng, true)}
        </li>
        {/* <li>{distance}</li> */}
      </ul>
      <div className="popup-bottom"></div>
    </MapOverlayGpxInfo>
  );
};

const MapOverlayGpxInfo = styled.div`
  width: max-content;
  padding: 1.3vh;
  ${(props) => props.color && COLOR[props.color]}
  color: #fff;
  border-radius: 10px;
  pointer-events: none;
  .popup-content {
    position: relative;
    list-style: none;
    margin: unset;
    padding: 0 0;
    font: 14px 'kopubM';
    pointer-events: auto;
  }
  .popup-content > li {
    padding: 4px 0;
    padding-right: 1vw;
  }
  .popup-bottom {
    width: 0;
    height: 0;
    position: absolute;
    left: 40%;
    // top: 100%;
    ${(props) => props.color && TOP[props.color]}
    border-left: 2vh solid transparent;
    border-right: 2vh solid transparent;
  }
`;

export default MapRescueOverlay;
